import { memo } from "react";

import { type Splide } from "@splidejs/splide";

import { CartUpsellCarouselPagination } from "@cart/CartUpsellCarousel/CartUpsellCarouselPagination.view";
import { CartUpsellItem } from "@cart/CartUpsellItem";
import { Carousel, Track, Slide } from "@react/components/Carousel";
import {
  PAGE_CAROUSEL_OPTIONS,
  TRANSPARENT_CLASS,
} from "@react/components/Carousel/constants";
import { type CartUpsellProductMetadata } from "@tablescape/state";
import { tw, type TTailwindString } from "classnames";

type Props = {
  btnAddLabel?: string;
  bundleValueText: string;
  upsellMetadata: CartUpsellProductMetadata[];
};

const cartUpsellCarouselOptions = {
  ...PAGE_CAROUSEL_OPTIONS,
  gap: 8,
  padding: { left: 24, right: 24 },
  breakpoints: {
    768: {
      gap: 16,
    },
  },
};

const styles = {
  container: tw("overflow-hidden", "relative"),
  track: tw("!overflow-visible" as TTailwindString),
};

const showArrows = (Splide: Splide) => {
  Object.values<HTMLButtonElement | undefined>(
    Splide.Components.Arrows?.arrows ?? {}
  ).forEach((arrow) => arrow?.classList.remove(TRANSPARENT_CLASS));
};

const CartUpsellCarouselBase = ({
  btnAddLabel,
  bundleValueText,
  upsellMetadata,
}: Props) => {
  return (
    <div className={styles.container}>
      <Carousel
        hasTrack={false}
        onArrowsMounted={showArrows}
        options={cartUpsellCarouselOptions}
      >
        <Track className={styles.track}>
          {upsellMetadata.map((upsell, index) => (
            <Slide key={upsell.id}>
              <CartUpsellItem
                btnAddLabel={btnAddLabel}
                bundleValueText={bundleValueText}
                position={index + 1}
                upsell={upsell}
              />
            </Slide>
          ))}
        </Track>

        <CartUpsellCarouselPagination />
      </Carousel>
    </div>
  );
};

export const CartUpsellCarousel = memo(CartUpsellCarouselBase);
